<div
  class="wrapper"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [class.is-disabled]="isDisabled()"
  [class.is-invalid]="errorState"
  [attr.aria-invalid]="errorState ? 'true' : null"
  (mousedown)="onFieldMousedown($event)"
>
  <div class="field">
    @for (chip of selectedOptions(); track chip) {
      <span class="chip">
        <span class="chip__label">{{ chip.label }}</span>
        <button
          type="button"
          class="chip__remove"
          tabindex="-1"
          [disabled]="isDisabled()"
          [attr.aria-label]="'Remove ' + chip.label"
          (click)="removeChip(chip, $event)"
        >
          <fa-icon [icon]="faXmark" />
        </button>
      </span>
    }

    <input
      #tagInput
      class="input"
      type="text"
      autocomplete="off"
      role="combobox"
      aria-autocomplete="list"
      [attr.aria-expanded]="dropdownOpen()"
      [id]="effectiveId"
      [placeholder]="selectedOptions().length ? '' : placeholder"
      [value]="query()"
      [disabled]="isDisabled()"
      (input)="onQueryInput($event)"
      (keydown)="onKeydown($event)"
    />
  </div>

  @if (clearable && !empty && !isDisabled() && !loading) {
    <button
      type="button"
      class="clear-btn"
      tabindex="-1"
      aria-label="Clear all"
      (mousedown)="$event.preventDefault()"
      (click)="clearAll($event)"
    >
      <fa-icon [icon]="faXmark" />
    </button>
  }

  @if (loading) {
    <span class="spinner" aria-hidden="true"></span>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="dropdownOpen()"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPositions]="overlayPositions"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div class="sui-tags-dropdown" role="listbox">
    @for (opt of filteredPool(); track opt.value; let i = $index) {
      <button
        type="button"
        role="option"
        class="sui-tags-dropdown__option"
        [class.is-active]="i === activeIndex()"
        [attr.aria-selected]="i === activeIndex()"
        (mousedown)="$event.preventDefault()"
        (mouseenter)="activeIndex.set(i)"
        (click)="selectOption(opt)"
      >
        {{ opt.label }}
      </button>
    }
  </div>
</ng-template>
